
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/re-branding",
      function () {
        return require("private-next-pages/franchise/re-branding.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/re-branding"])
      });
    }
  